export default [
    {
        name: 'MainMenu',
        path: '/main-menu',
        component: () => import('@/pages/IpadPreview/MainMenu')
    }
];
